import React, { useState } from "react";

const Accordion = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="mb-4">
      <button
        onClick={toggleAccordion}
        className="w-full text-left p-2 bg-gray-200 rounded-lg"
      >
        <h3 className="text-sm">{title}</h3>
      </button>
      {isOpen && (
        <div className="p-2 border border-gray-300 rounded-lg">{children}</div>
      )}
    </div>
  );
};

const getDistributionWorks = (dnoInfo, AOI) => {
  if (
    AOI === "Bournemouth, UK" ||
    AOI === "Poole, UK" ||
    AOI === "Southampton, UK" ||
    AOI === "Portsmouth, UK"
  ) {
    if (dnoInfo?.substation_info?.distribution_works !== null) {
      return dnoInfo?.substation_info?.distribution_works;
    }
    if (dnoInfo?.bsp?.distribution_works !== null) {
      return dnoInfo?.bsp?.distribution_works;
    }
    if (dnoInfo?.gsp?.distribution_works !== null) {
      return dnoInfo?.gsp?.distribution_works;
    }
    return "No distribution works available";
  }

  if (dnoInfo.primary_substation.distribution_works !== "nan") {
    return dnoInfo.primary_substation.distribution_works;
  }
  if (dnoInfo.bsp.distribution_works !== "nan") {
    return dnoInfo.bsp.distribution_works;
  }
  if (dnoInfo.gsp.distribution_works !== "nan") {
    return dnoInfo.gsp.distribution_works;
  }
  return "No distribution works available";
};

const getTransmissionWorks = (dnoInfo, AOI) => {
  if (
    AOI === "Bournemouth, UK" ||
    AOI === "Poole, UK" ||
    AOI === "Southampton, UK" ||
    AOI === "Portsmouth, UK"
  ) {
    if (
      dnoInfo?.substation_info?.transmission_works !== null &&
      dnoInfo?.substation_info?.transmission_works !== "nan" &&
      dnoInfo?.substation_info?.transmission_works !== "NaT"
    ) {
      return dnoInfo?.substation_info?.transmission_works;
    }
    if (
      dnoInfo?.bsp?.transmission_works !== null &&
      dnoInfo?.bsp?.transmission_works !== "nan" &&
      dnoInfo?.bsp?.transmission_works !== "NaT"
    ) {
      return dnoInfo?.bsp?.transmission_works;
    }
    if (
      dnoInfo?.gsp?.transmission_works !== null &&
      dnoInfo?.gsp?.transmission_works !== "nan" &&
      dnoInfo?.gsp?.transmission_works !== "NaT"
    ) {
      return dnoInfo?.gsp?.transmission_works;
    }
    return "No transmission works available";
  }

  if (dnoInfo.primary_substation.transmission_works !== "nan") {
    return dnoInfo.primary_substation.transmission_works;
  }
  if (dnoInfo.bsp.transmission_works !== "nan") {
    return dnoInfo.bsp.transmission_works;
  }
  if (dnoInfo.gsp.transmission_works !== "nan") {
    return dnoInfo.gsp.transmission_works;
  }
  return "No transmission works available";
};

const getTransmissionReinforcementDate = (dnoInfo, AOI) => {
  if (
    AOI === "Bournemouth, UK" ||
    AOI === "Poole, UK" ||
    AOI === "Southampton, UK" ||
    AOI === "Portsmouth, UK"
  ) {
    if (
      dnoInfo?.substation_info?.transmission_reinforcement_date !== null &&
      dnoInfo?.substation_info?.transmission_reinforcement_date !== "nan" &&
      dnoInfo?.substation_info?.transmission_reinforcement_date !== "NaT"
    ) {
      return dnoInfo?.substation_info?.transmission_reinforcement_date;
    }
    if (
      dnoInfo?.bsp?.transmission_reinforcement_date !== null &&
      dnoInfo?.bsp?.transmission_reinforcement_date !== "nan" &&
      dnoInfo?.bsp?.transmission_reinforcement_date !== "NaT"
    ) {
      return dnoInfo?.bsp?.transmission_reinforcement_date;
    }
    if (
      dnoInfo?.gsp?.transmission_reinforcement_date !== null &&
      dnoInfo?.gsp?.transmission_reinforcement_date !== "nan" &&
      dnoInfo?.gsp?.transmission_reinforcement_date !== "NaT"
    ) {
      return dnoInfo?.gsp?.transmission_reinforcement_date;
    }
    return "No transmission reinforcement date available";
  }
};

const getDistributionReinforcementDate = (dnoInfo, AOI) => {
  if (
    AOI === "Bournemouth, UK" ||
    AOI === "Poole, UK" ||
    AOI === "Southampton, UK" ||
    AOI === "Portsmouth, UK"
  ) {
    if (
      dnoInfo?.substation_info?.distribution_reinforcement_date !== null &&
      dnoInfo?.substation_info?.distribution_reinforcement_date !== "nan" &&
      dnoInfo?.substation_info?.distribution_reinforcement_date !== "NaT"
    ) {
      return dnoInfo?.substation_info?.distribution_reinforcement_date;
    }
    if (
      dnoInfo?.bsp?.distribution_reinforcement_date !== null &&
      dnoInfo?.bsp?.distribution_reinforcement_date !== "nan" &&
      dnoInfo?.bsp?.distribution_reinforcement_date !== "NaT"
    ) {
      return dnoInfo?.bsp?.distribution_reinforcement_date;
    }
    if (
      dnoInfo?.gsp?.distribution_reinforcement_date !== null &&
      dnoInfo?.gsp?.distribution_reinforcement_date !== "nan" &&
      dnoInfo?.gsp?.distribution_reinforcement_date !== "NaT"
    ) {
      return dnoInfo?.gsp?.distribution_reinforcement_date;
    }
    return "No distribution reinforcement date available";
  }
};

function DnoData({ AOI, point }) {
  if (AOI === "Aylesbury, UK") {
    const { building_info, land_reg_info } = point;

    return (
      <div className="p-4 bg-white shadow-lg rounded-lg border border-gray-200">
        {!building_info && <p>No info available</p>}
        {building_info.company_info &&
          building_info.company_info.length > 0 &&
          building_info.company_info.map((company, index) => (
            <Accordion key={index} title={company.title}>
              <div className="space-y-2">
                <p>
                  <span className="font-medium">Address:</span>{" "}
                  {company.address_snippet}
                </p>
                <p>
                  <span className="font-medium">Company Number:</span>{" "}
                  {company.company_number}
                </p>
                <p>
                  <span className="font-medium">Status:</span>{" "}
                  {company.company_status}
                </p>
                <p>
                  <span className="font-medium">Type:</span>{" "}
                  {company.company_type}
                </p>
                <p>
                  <span className="font-medium">SIC Codes:</span>{" "}
                  {company.sic_codes.join(", ")}
                </p>
              </div>
            </Accordion>
          ))}
        {land_reg_info && land_reg_info.length > 0 && (
          <Accordion title="Land Registration Info">
            {land_reg_info.map((landReg, index) => (
              <Accordion
                key={index}
                title={`Land Registration Info ${index + 1}`}
              >
                <div className="space-y-2">
                  <p>
                    <span className="font-medium">Constraints:</span>{" "}
                    {landReg?.constraints.join(", ")}
                  </p>
                  <p>
                    <span className="font-medium">Proprietor:</span>{" "}
                    {landReg?.proprietor.map((prop, idx) => (
                      <span key={idx}>
                        {prop?.name} ({prop?.company_registration_no}) -{" "}
                        {prop?.address.join(", ")}
                      </span>
                    ))}
                  </p>
                  <p>
                    <span className="font-medium">Ownership Category:</span>{" "}
                    {landReg?.ownership_category}
                  </p>
                </div>
              </Accordion>
            ))}
          </Accordion>
        )}
      </div>
    );
  }

  if (AOI === "Bournemouth, UK") {
    const { building_info, dno_info, land_reg_info } = point;

    return (
      <div className="p-4 bg-white shadow-lg rounded-lg border border-gray-200">
        {!building_info && <p>No info available</p>}
        {building_info.company_info &&
          building_info.company_info.length > 0 &&
          building_info.company_info.map((company, index) => (
            <Accordion key={index} title={company.title}>
              <div className="space-y-2">
                <p>
                  <span className="font-medium">Address:</span>{" "}
                  {company.address_snippet}
                </p>
                <p>
                  <span className="font-medium">Company Number:</span>{" "}
                  {company.company_number}
                </p>
                <p>
                  <span className="font-medium">Status:</span>{" "}
                  {company.company_status}
                </p>
                <p>
                  <span className="font-medium">Type:</span>{" "}
                  {company.company_type}
                </p>
                <p>
                  <span className="font-medium">SIC Codes:</span>{" "}
                  {company.sic_codes.join(", ")}
                </p>
              </div>
            </Accordion>
          ))}
        {dno_info && Object.keys(dno_info).length > 0 && (
          <Accordion title="Dno Info">
            <div className="space-y-2">
              <p>
                <span className="font-medium">Available Headroom (MVA):</span>{" "}
                {dno_info?.substation_info?.available_headroom_mva}
              </p>
              <p>
                <span className="font-medium">Color Rating:</span>{" "}
                {dno_info?.substation_info?.color_rating}
              </p>
              <p>
                <span className="font-medium">Distribution Works:</span>{" "}
                {getDistributionWorks(dno_info, AOI)}
              </p>
              <p>
                <span className="font-medium">
                  Distribution Reinforcement Date:
                </span>{" "}
                {getDistributionReinforcementDate(dno_info, AOI)}
              </p>
              <p>
                <span className="font-medium">Transmission Works:</span>{" "}
                {getTransmissionWorks(dno_info, AOI)}
              </p>
              <p>
                <span className="font-medium">
                  Transmission Reinforcement Date:
                </span>{" "}
                {getTransmissionReinforcementDate(dno_info, AOI)}
              </p>
            </div>
          </Accordion>
        )}
        {land_reg_info && land_reg_info.length > 0 && (
          <Accordion title="Land Registration Info">
            {land_reg_info.map((landReg, index) => (
              <Accordion
                key={index}
                title={`Land Registration Info ${index + 1}`}
              >
                <div className="space-y-2">
                  <p>
                    <span className="font-medium">Constraints:</span>{" "}
                    {landReg?.constraints.join(", ")}
                  </p>
                  <p>
                    <span className="font-medium">Proprietor:</span>{" "}
                    {landReg?.proprietor.map((prop, idx) => (
                      <span key={idx}>
                        {prop?.name} ({prop?.company_registration_no}) -{" "}
                        {prop?.address.join(", ")}
                      </span>
                    ))}
                  </p>
                  <p>
                    <span className="font-medium">Ownership Category:</span>{" "}
                    {landReg?.ownership_category}
                  </p>
                </div>
              </Accordion>
            ))}
          </Accordion>
        )}
      </div>
    );
  }

  if (AOI === "Coventry, UK") {
    const { dno_info, land_reg_info } = point;

    return (
      <div className="p-4 bg-white shadow-lg rounded-lg border border-gray-200">
        {!dno_info && <p>No info available</p>}
        {dno_info && dno_info.headroom_info && (
          <Accordion title="Headroom Info">
            <div className="space-y-2">
              <p>
                <span className="font-medium">Generation Headroom (MVA):</span>{" "}
                {dno_info?.headroom_info[0]?.["Generation_Headroom_(MVA)"]}
              </p>
              <p>
                <span className="font-medium">Generation Headroom RAG:</span>{" "}
                {dno_info?.headroom_info[0]?.Generation_Headroom_RAG}
              </p>
              <p>
                <span className="font-medium">Substation Name:</span>{" "}
                {dno_info?.headroom_info[0]?.Substation_Name}
              </p>
              <p>
                <span className="font-medium">Statement of works:</span>{" "}
                {dno_info?.headroom_info[0]?.Statement_of_Works}
              </p>
            </div>
          </Accordion>
        )}
        {dno_info && dno_info.substation_info && (
          <Accordion title="Substation Info">
            <div className="space-y-2">
              <p>
                <span className="font-medium">Bulk Supply Point Name:</span>{" "}
                {dno_info?.substation_info?.["Bulk Supply Point Name"]}
              </p>
              <p>
                <span className="font-medium">Grid Supply Point Name:</span>{" "}
                {dno_info?.substation_info?.["Grid Supply Point Name"]}
              </p>
              <p>
                <span className="font-medium">Primary Name:</span>{" "}
                {dno_info?.substation_info?.["Primary Name"]}
              </p>
            </div>
          </Accordion>
        )}
        {land_reg_info && land_reg_info.length > 0 && (
          <Accordion title="Land Registration Info">
            {land_reg_info.map((landReg, index) => (
              <Accordion
                key={index}
                title={`Land Registration Info ${index + 1}`}
              >
                <div className="space-y-2">
                  <p>
                    <span className="font-medium">Constraints:</span>{" "}
                    {landReg?.constraints.join(", ")}
                  </p>
                  <p>
                    <span className="font-medium">Proprietor:</span>{" "}
                    {landReg?.proprietor.map((prop, idx) => (
                      <span key={idx}>
                        {prop?.name} ({prop?.company_registration_no}) -{" "}
                        {prop?.address.join(", ")}
                      </span>
                    ))}
                  </p>
                  <p>
                    <span className="font-medium">Ownership Category:</span>{" "}
                    {landReg?.ownership_category}
                  </p>
                </div>
              </Accordion>
            ))}
          </Accordion>
        )}
      </div>
    );
  }

  if (AOI === "Portsmouth, UK") {
    const { building_info, dno_info, land_reg_info } = point;

    return (
      <div className="p-4 bg-white shadow-lg rounded-lg border border-gray-200">
        {building_info.company_info &&
          building_info.company_info.length > 0 &&
          building_info.company_info.map((company, index) => (
            <Accordion key={index} title={company.title}>
              <div className="space-y-2">
                <p>
                  <span className="font-medium">Address:</span>{" "}
                  {company?.address_snippet}
                </p>
                <p>
                  <span className="font-medium">Company Number:</span>{" "}
                  {company?.company_number}
                </p>
                <p>
                  <span className="font-medium">Status:</span>{" "}
                  {company?.company_status}
                </p>
                <p>
                  <span className="font-medium">Type:</span>{" "}
                  {company?.company_type}
                </p>
                <p>
                  <span className="font-medium">SIC Codes:</span>{" "}
                  {company?.sic_codes.join(", ")}
                </p>
              </div>
            </Accordion>
          ))}
        {dno_info && Object.keys(dno_info).length > 0 && (
          <Accordion title="DNO Info">
            <div className="space-y-2">
              <p>
                <span className="font-medium">Available Headroom (MVA):</span>{" "}
                {dno_info?.substation_info?.available_headroom_mva}
              </p>
              <p>
                <span className="font-medium">Color Rating:</span>{" "}
                {dno_info?.substation_info?.color_rating}
              </p>
              <p>
                <span className="font-medium">Distribution Works:</span>{" "}
                {getDistributionWorks(dno_info, AOI)}
              </p>
              <p>
                <span className="font-medium">
                  Distribution Reinforcement Date:
                </span>{" "}
                {getDistributionReinforcementDate(dno_info, AOI)}
              </p>
              <p>
                <span className="font-medium">Transmission Works:</span>{" "}
                {getTransmissionWorks(dno_info, AOI)}
              </p>
              <p>
                <span className="font-medium">
                  Transmission Reinforcement Date:
                </span>{" "}
                {getTransmissionReinforcementDate(dno_info, AOI)}
              </p>
            </div>
          </Accordion>
        )}
        {land_reg_info && land_reg_info.length > 0 && (
          <Accordion title="Land Registration Info">
            {land_reg_info.map((landReg, index) => (
              <Accordion
                key={index}
                title={`Land Registration Info ${index + 1}`}
              >
                <div className="space-y-2">
                  <p>
                    <span className="font-medium">Constraints:</span>{" "}
                    {landReg?.constraints.join(", ")}
                  </p>
                  <p>
                    <span className="font-medium">Proprietor:</span>{" "}
                    {landReg?.proprietor.map((prop, idx) => (
                      <span key={idx}>
                        {prop?.name} ({prop?.company_registration_no}) -{" "}
                        {prop?.address.join(", ")}
                      </span>
                    ))}
                  </p>
                  <p>
                    <span className="font-medium">Ownership Category:</span>{" "}
                    {landReg?.ownership_category}
                  </p>
                </div>
              </Accordion>
            ))}
          </Accordion>
        )}
      </div>
    );
  }

  if (AOI === "Southampton, UK") {
    const { building_info, dno_info, land_reg_info } = point;

    return (
      <div className="p-4 bg-white shadow-lg rounded-lg border border-gray-200">
        {building_info.company_info &&
          building_info.company_info.length > 0 &&
          building_info.company_info.map((company, index) => (
            <Accordion key={index} title={company.title}>
              <div className="space-y-2">
                <p>
                  <span className="font-medium">Address:</span>{" "}
                  {company?.address_snippet}
                </p>
                <p>
                  <span className="font-medium">Company Number:</span>{" "}
                  {company?.company_number}
                </p>
                <p>
                  <span className="font-medium">Status:</span>{" "}
                  {company?.company_status}
                </p>
                <p>
                  <span className="font-medium">Type:</span>{" "}
                  {company?.company_type}
                </p>
                <p>
                  <span className="font-medium">SIC Codes:</span>{" "}
                  {company?.sic_codes.join(", ")}
                </p>
              </div>
            </Accordion>
          ))}
        {dno_info && Object.keys(dno_info).length > 0 && (
          <Accordion title="DNO Info">
            <div className="space-y-2">
              <p>
                <span className="font-medium">Available Headroom (MVA):</span>{" "}
                {dno_info?.substation_info?.available_headroom_mva}
              </p>
              <p>
                <span className="font-medium">Color Rating:</span>{" "}
                {dno_info?.substation_info?.color_rating}
              </p>
              <p>
                <span className="font-medium">Distribution Works:</span>{" "}
                {getDistributionWorks(dno_info, AOI)}
              </p>
              <p>
                <span className="font-medium">
                  Distribution Reinforcement Date:
                </span>{" "}
                {getDistributionReinforcementDate(dno_info, AOI)}
              </p>
              <p>
                <span className="font-medium">Transmission Works:</span>{" "}
                {getTransmissionWorks(dno_info, AOI)}
              </p>
              <p>
                <span className="font-medium">
                  Transmission Reinforcement Date:
                </span>{" "}
                {getTransmissionReinforcementDate(dno_info, AOI)}
              </p>
            </div>
          </Accordion>
        )}
        {land_reg_info && land_reg_info.length > 0 && (
          <Accordion title="Land Registration Info">
            {land_reg_info.map((landReg, index) => (
              <Accordion
                key={index}
                title={`Land Registration Info ${index + 1}`}
              >
                <div className="space-y-2">
                  <p>
                    <span className="font-medium">Constraints:</span>{" "}
                    {landReg?.constraints.join(", ")}
                  </p>
                  <p>
                    <span className="font-medium">Proprietor:</span>{" "}
                    {landReg?.proprietor.map((prop, idx) => (
                      <span key={idx}>
                        {prop?.name} ({prop?.company_registration_no}) -{" "}
                        {prop?.address.join(", ")}
                      </span>
                    ))}
                  </p>
                  <p>
                    <span className="font-medium">Ownership Category:</span>{" "}
                    {landReg?.ownership_category}
                  </p>
                </div>
              </Accordion>
            ))}
          </Accordion>
        )}
      </div>
    );
  }

  if (AOI === "Poole, UK") {
    const { dno_info, land_reg_info } = point;

    return (
      <div className="p-4 bg-white shadow-lg rounded-lg border border-gray-200">
        {dno_info && Object.keys(dno_info).length > 0 && (
          <Accordion title="DNO Info">
            <div className="space-y-2">
              <p>
                <span className="font-medium">Available Headroom (MVA):</span>{" "}
                {dno_info?.substation_info?.available_headroom_mva}
              </p>
              <p>
                <span className="font-medium">Color Rating:</span>{" "}
                {dno_info?.substation_info?.color_rating}
              </p>
              <p>
                <span className="font-medium">Distribution Works:</span>{" "}
                {getDistributionWorks(dno_info, AOI)}
              </p>
              <p>
                <span className="font-medium">
                  Distribution Reinforcement Date:
                </span>{" "}
                {getDistributionReinforcementDate(dno_info, AOI)}
              </p>
              <p>
                <span className="font-medium">Transmission Works:</span>{" "}
                {getTransmissionWorks(dno_info, AOI)}
              </p>
              <p>
                <span className="font-medium">
                  Transmission Reinforcement Date:
                </span>{" "}
                {getTransmissionReinforcementDate(dno_info, AOI)}
              </p>
            </div>
          </Accordion>
        )}
        {land_reg_info && land_reg_info.length > 0 && (
          <Accordion title="Land Registration Info">
            {land_reg_info.map((landReg, index) => (
              <Accordion
                key={index}
                title={`Land Registration Info ${index + 1}`}
              >
                <div className="space-y-2">
                  <p>
                    <span className="font-medium">Constraints:</span>{" "}
                    {landReg?.constraints.join(", ")}
                  </p>
                  <p>
                    <span className="font-medium">Proprietor:</span>{" "}
                    {landReg?.proprietor.map((prop, idx) => (
                      <span key={idx}>
                        {prop?.name} ({prop?.company_registration_no}) -{" "}
                        {prop?.address.join(", ")}
                      </span>
                    ))}
                  </p>
                  <p>
                    <span className="font-medium">Ownership Category:</span>{" "}
                    {landReg?.ownership_category}
                  </p>
                </div>
              </Accordion>
            ))}
          </Accordion>
        )}
      </div>
    );
  }
  return null;
}

export default DnoData;
